<template>
    <div class="m-card" id="app">
        <el-card class="box-card">
            <CardHeader />
            <Msg />
            <main v-if="success == null" class="m-main">
                <form ref="registerForm">
                    <!-- 账号 -->
                    <div class="u-email">
                        <el-input class="u-text u-email" v-model="email" placeholder="邮箱地址" minlength="3" maxlength="50" type="email" @change="checkEmail">
                            <template slot="prepend">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" v-bind:class="'i-mail'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M467 61H45C20.218 61 0 81.196 0 106v300c0 24.72 20.128 45 45 45h422c24.72 0 45-20.128 45-45V106c0-24.72-20.128-45-45-45zm-6.214 30L256.954 294.833 51.359 91h409.427zM30 399.788V112.069l144.479 143.24L30 399.788zM51.213 421l144.57-144.57 50.657 50.222c5.864 5.814 15.327 5.795 21.167-.046L317 277.213 460.787 421H51.213zM482 399.787L338.213 256 482 112.212v287.575z"/></svg>
                            </template>
                        </el-input>
                        <i v-show="email_available == true" class="el-icon-success u-ok"></i>
                        <div class="u-tip">
                            <el-alert v-show="email_validate == false" :title="email_validate_tip" type="error" show-icon :closable="false"></el-alert>
                            <el-alert v-show="email_available == false" :title="email_available_tip" type="error" show-icon :closable="false"></el-alert>
                        </div>
                    </div>

                    <!-- 密码 -->
                    <div class="u-pass">
                        <el-input class="u-text" placeholder="输入密码" v-model="pass" show-password @input="checkPass">
                            <template slot="prepend">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" v-bind:class="'i-pass'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M437.333 192h-32v-42.667C405.333 66.99 338.344 0 256 0S106.667 66.99 106.667 149.333V192h-32A10.66 10.66 0 0064 202.667v266.667C64 492.865 83.135 512 106.667 512h298.667C428.865 512 448 492.865 448 469.333V202.667A10.66 10.66 0 00437.333 192zM287.938 414.823a10.67 10.67 0 01-10.604 11.844h-42.667a10.67 10.67 0 01-10.604-11.844l6.729-60.51c-10.927-7.948-17.458-20.521-17.458-34.313 0-23.531 19.135-42.667 42.667-42.667s42.667 19.135 42.667 42.667c0 13.792-6.531 26.365-17.458 34.313l6.728 60.51zM341.333 192H170.667v-42.667C170.667 102.281 208.948 64 256 64s85.333 38.281 85.333 85.333V192z"/></svg>
                            </template>
                        </el-input>
                        <div class="u-tip">
                            <el-alert v-show="pass_validate == false" :title="pass_validate_tip" type="error" show-icon :closable="false"></el-alert>
                        </div>
                    </div>

                    <div class="u-terms">
                        <el-checkbox v-model="agreement" class="u-checkbox"
                            >我已阅读并同意<a href="/about/license" target="_blank">《用户协议》</a>、<a href="/about/privacy" target="_blank">《隐私政策》</a>、<a href="/about/treaty" target="_blank"
                                >《创作公约》</a
                            ></el-checkbox
                        >
                    </div>

                    <!-- 提交 -->
                    <el-button class="u-submit u-button" type="primary" @click="submit" :disabled="!ready">注册</el-button>
                </form>
                <footer class="m-footer">
                    <p class="u-login">已有账号? <a :href="login_url">登录 &raquo;</a></p>
                    <p class="u-resetpwd">
                        <a href="../password_reset">忘记密码?</a>
                    </p>
                </footer>
            </main>

            <main v-if="success == true" class="m-main">
                <el-alert title="注册成功" type="success" description="一封邮箱验证的邮件已发送至您的邮箱,请注意查收" show-icon :closable="false"> </el-alert>
                <a class="u-skip el-button u-button el-button--primary" :href="login_url">立即登录</a>
            </main>

            <main v-if="success == false" class="m-main">
                <el-alert title="注册失败" type="error" :description="failtips" show-icon :closable="false"> </el-alert>
                <el-button class="u-button u-submit" type="primary" @click="reset">返回</el-button>
            </main>
        </el-card>
        <Bottom />
    </div>
</template>

<script>
const { validator } = require("sterilizer");
import CardHeader from "@/components/CardHeader.vue";
import { checkEmail, registerByEmail } from "@/service/email.js";
import { __Root } from "@jx3box/jx3box-common/data/jx3box.json";
import Msg from "@/components/Msg.vue";
export default {
    name: "Register",
    data: function () {
        return {
            email: "",
            email_validate: null,
            email_validate_tip: "必须为有效的Email,长度限3-50个字符",
            email_available: null,
            email_available_tip: "邮箱地址已被使用",

            pass: "",
            pass_validate: null,
            pass_validate_tip: "密码有效长度为6-50个字符",

            success: null,
            failtips: "请求异常,请重试",

            homepage: __Root,
            redirect: "",

            agreement: false,
        };
    },
    computed: {
        ready: function () {
            return this.email_validate && this.email_available && this.pass_validate && this.agreement;
        },
        login_url: function () {
            return "../login?redirect=" + this.redirect;
        },
    },
    methods: {
        checkEmail: function () {
            // 如果为空
            if (this.email == "") {
                this.email_validate = null;
                this.email_available = null;
                return;
            }

            // 校验格式
            let result = validator(this.email, {
                isEmail: true,
                len: [3, 50],
            });
            this.email_validate = result;

            // 检查可用性
            if (result) {
                checkEmail(this.email).then((res) => {
                    this.email_available = res.data.data;
                });
            } else {
                this.email_available = null;
            }
        },
        checkPass: function () {
            // 如果为空
            if (this.pass == "") {
                this.pass_validate = null;
                return;
            }

            // 校验格式
            let result = validator(this.pass, {
                len: [6, 50],
            });
            this.pass_validate = result;
        },
        submit: function () {
            if (this.ready) {
                registerByEmail({
                    email: this.email,
                    pass: this.pass,
                })
                    .then((res) => {
                        if (!res.data.code) {
                            this.success = true;
                        } else {
                            this.success = false;
                            this.failtips = res.data.msg;
                        }
                    })
                    .catch((err) => {
                        this.success = false;
                        this.failtips = "网络请求异常,请稍后重试";
                    });
            }
        },
        reset: function () {
            this.success = null;
            this.email_validate = null;
            this.email_available = null;
            this.pass_validate = null;
        },
        checkDirect: function () {
            let search = new URLSearchParams(document.location.search);
            let redirect = search.get("redirect");
            if (redirect) {
                this.redirect = redirect;
            } else {
                this.redirect = this.homepage;
            }
        },
    },
    filters: {},
    mounted: function () {
        this.checkDirect();
    },
    components: {
        CardHeader,
        Msg,
    },
};
</script>

<style lang="less">
@import "../../assets/css/common.less";
@import "../../assets/css/card.less";
@import "../../assets/css/register.less";
</style>
